"use client";

import type { ResourcesConfig } from "aws-amplify";
import { clientEnv } from "@/lib/env.client";

// Get the current origin dynamically
const webOrigin = clientEnv().NEXT_PUBLIC_WEB_ORIGIN;

// Build a unique set of redirect URLs
const signInPaths = ["/login/check"];
const uniqueOrigins = new Set([
  webOrigin,
  "http://localhost:3001",
  "https://dc-two-web.onrender.com",
  "https://dc-two-web.ml.documentcrunch.com",
  // Add current browser origin if available (for preview deployments)
  ...(typeof window !== "undefined" ? [window.location.origin] : []),
]);

// Generate redirect URLs for all unique origins
const redirectSignInUrls = Array.from(uniqueOrigins).flatMap((origin) => signInPaths.map((path) => `${origin}${path}`));

const redirectSignOutUrls = Array.from(uniqueOrigins);

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: clientEnv().NEXT_PUBLIC_COGNITO_USER_POOL_ID,
      userPoolClientId: clientEnv().NEXT_PUBLIC_COGNITO_USER_POOL_CLIENT_ID,
      signUpVerificationMethod: "code" as const,
      loginWith: {
        email: true,
        username: true,
        oauth: {
          domain: clientEnv().NEXT_PUBLIC_COGNITO_DOMAIN,
          scopes: ["openid", "email", "phone", "profile"],
          redirectSignIn: redirectSignInUrls,
          redirectSignOut: redirectSignOutUrls,
          responseType: "code",
        },
      },
    },
  },
};
